var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isAuth)?_c('menu-superior'):_vm._e(),_vm._v(" "),_c('router-view',{key:_vm.$route.fullPath}),_vm._v(" "),_c('rastreamento-modal',{attrs:{"id":_vm.id},on:{"closed":function($event){_vm.id = null}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }